import React, { useCallback, useEffect, useState } from "react"
import { compareVersions } from "compare-versions"
import axios from "axios"

import { ipcApi } from "utils"
import FuvmDownloadButton from "./FuvmDownloadButton"
import FuvmProgressBar from "./FuvmProgressBar"
import FuvmInstalling from "./FuvmInstalling"
import { Modal } from "components"
import classes from "./index.module.scss"

const initialProgressState = {
  transferredBytes: 0,
  totalBytes: 0,
  percent: 0
}

const ForceUpdateVersionModal = () => {
  const [progress, setProgress] = useState(initialProgressState)
  const [latestVersion, setLatestVersion] = useState(null)
  const [downloadStatus, setDownloadStatus] = useState("download-not-started")
  const [openAppVersionModal, setOpenAppVersionModal] = useState(false)

  const handleStartDownload = async () => {
    ipcApi({
      type: "downloadLatestAppVersion",
      url: latestVersion.windowsUrl,
      version: latestVersion.forceWindowsVersion
    })

    window.ipcRenderer.on(
      "app-download-progress",
      handleAppDownloadProgress
    )
  }

  const checkAppVersions = async (latestVersion) => {
    const currentAppVersion =
      await ipcApi({ type: "appVersion" })

    const result =
      compareVersions(
        currentAppVersion,
        latestVersion.forceWindowsVersion
      )

    setOpenAppVersionModal(result === -1)
  }

  const fetchLatestAppVersion = async () => {
    try {
      const response =
        await axios.get(`https://api.farasod.com/subscribe/setting`)

      const latestVersion =
        response.data.posSystem.versionControl

      setLatestVersion(latestVersion)

      localStorage.setItem(
        "latestAppVersionDetails",
        JSON.stringify(latestVersion)
      )

      checkAppVersions(latestVersion)
    } catch (err) {
      console.log(err)

      const json =
        localStorage.getItem(
          "latestAppVersionDetails"
        )

      if (!json) return

      const latestAppVersionDetails = JSON.parse(json)

      checkAppVersions(latestAppVersionDetails)
    }
  }

  const handleAppDownloadProgress =
    useCallback((e, data) => {
      const {
        status,
        transferredBytes,
        totalBytes,
        percent
      } = data

      setDownloadStatus(status)

      !isNaN(percent) &&
        setProgress({
          transferredBytes,
          totalBytes,
          percent
        })
    }, [])

  useEffect(() => {
    fetchLatestAppVersion()

    return () => {
      window.ipcRenderer.off(
        "app-download-progress",
        handleAppDownloadProgress
      )
    }
  }, [])

  const showDownloadButton =
    downloadStatus === "download-not-started" ||
    downloadStatus === "download-canceled"

  return (
    <Modal
      
      backdrop="static"
      onHide={() => setOpenAppVersionModal(false)}
      show={openAppVersionModal}
    >
      <div className={classes["container"]}>
        {
          showDownloadButton &&
          <FuvmDownloadButton
            latestVersion={latestVersion}
            handleStartDownload={handleStartDownload}
          />
        }
        {
          downloadStatus === "downloading" &&
          <FuvmProgressBar
            progress={progress}
          />
        }
        {
          downloadStatus === "download-completed" &&
          <FuvmInstalling
            forceWindowsVersion={latestVersion.forceWindowsVersion}
          />
        }
      </div>
    </Modal>
  )
}

export default ForceUpdateVersionModal